import React from 'react'
import {
  FormControlLabel,
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
} from '@material-ui/core'

export type CheckboxProps = MuiCheckboxProps & {
  label?: string
}

export function Checkbox(props: CheckboxProps): React.ReactElement {
  const { label, ...checkboxProps } = props

  if (!label) {
    return <MuiCheckbox {...checkboxProps} />
  }

  return (
    <FormControlLabel
      control={<MuiCheckbox {...checkboxProps} />}
      label={label}
    />
  )
}
